import React, { Suspense, useEffect, useState, useTransition } from 'react';

const SuspenseHelper = ({ fallback, children }) => {
  const isBrowser = typeof window !== `undefined`;
  const [isMounted, setIsMounted] = useState(false);
  const [, startTransition] = useTransition();

  useEffect(() => {
    if (!isMounted) {
      // Wrap state update in startTransition to prevent hydration errors
      // This tells React the update is not urgent and can be deferred
      startTransition(() => {
        setIsMounted(true);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Suspense fallback={fallback}>
      {!isBrowser || !isMounted ? fallback : children}
    </Suspense>
  );
};

export default SuspenseHelper;
